$(function() {
    // Development Footer links
    // On hover add BG color
    if( $('#dev-hero').length ) {
        $herFooterBtns = $("#dev-hero .hero-footer .dev-hero-btns");
        $herFooterBtns.on("mouseover", function () {
            var bgColor = $(this).data('bg-color');
            var $bgUnderlay = $(this).find('.bg-underlay');
            $bgUnderlay.css('background-color', bgColor);
        });
        $herFooterBtns.on("mouseout", function () {
            var $bgUnderlay = $(this).find('.bg-underlay');
            $bgUnderlay.css('background-color', '');
        });
    }
    
});